import RestClient from './RestClient';
import { getApiErrorMessage } from './getApiErrorMessage';
import { Ticket } from '../../models';

class Tickets extends RestClient {
    constructor() {
        super({
            "model": Ticket,
            "entryPoint": "ticket",
            "resource": "ticket",
            "resources": "tickets",
            "id_field": "_id"
        });
    }

    importTickets(data, options = null) {
        const payload = data?.length > 0 ? { data } : {};
        if (options && Object.keys(options).length > 0) {
            if (options.source) {
                payload.source = options.source;
                if (!payload.data?.length) {
                    const { source, ...rest } = options;
                    options = Object.keys(rest).length > 0 ? rest : null;
                }
            }
            if (options)
                payload.options = options;
        }

        return this.POST('/ticket/import', payload)
            .then(response => response.json())
            .then(json => {
                if (json.imported)
                    return json;
                throw new Error(getApiErrorMessage(json));
            });
    }

    previewTickets(source = null) {
        const options = { dry_run: true };
        if (source)
            options.source = source;

        return this.POST('/ticket/import', { options })
            .then(response => response.json())
            .then(json => {
                if (json.imported?.preview)
                    return json.imported.preview;
                throw new Error(getApiErrorMessage(json, 'Preview failed'));
            });
    }

    updateWallets(ids, mode, amount) {
        const payload = { ids, mode, amount };

        return this.POST('/ticket/wallet', payload)
            .then(response => response.json())
            .then(json => {
                if (json.wallets)
                    return json;
                throw new Error(getApiErrorMessage(json));
            });
    }

    updateArticles(ids, mode, articleId, variantId, quantity) {
        const payload = {
            ids,
            mode,
            article_id: articleId,
            variant_id: variantId,
            quantity,
        };

        return this.POST('/ticket/articles', payload)
            .then(response => response.json())
            .then(json => {
                if (json.articles)
                    return json;
                throw new Error(getApiErrorMessage(json, 'Unable to update articles'));
            });
    }

    getPdfUrls(ids, layout = 'paper', salepointId = null, options = {}) {
        const payload = { ids, layout, ...options };
        if (salepointId)
            payload.salepoint_id = salepointId;

        return this.POST('/ticket/pdf_urls', payload)
            .then(response => response.json())
            .then(json => {
                if (json.pdf_urls || json.zip_urls)
                    return json;
                throw new Error(json?.flash?.error || 'Unable to generate PDFs');
            });
    }

    /**
     * Download the Engine ticket PDF through Kore (same render as getPdfUrls).
     *
     * @param {string[]} ids
     * @param {string} [layout]
     * @param {string|null} [salepointId]
     * @param {object} [options]
     * @returns {Promise<Blob>}
     */
    getPdf(ids, layout = 'paper', salepointId = null, options = {}) {
        const payload = { ids, layout, ...options };
        if (salepointId)
            payload.salepoint_id = salepointId;

        return this.POST('/ticket/pdf', payload, null, {
            Accept: 'application/pdf',
        }).then(async (response) => {
            if (response.ok)
                return response.blob();

            let message = 'Unable to generate PDF';
            try {
                const json = await response.json();
                message = json?.flash?.error || message;
            } catch (e) {
                // ignore parse errors on non-json bodies
            }
            throw new Error(message);
        });
    }
}

const TicketsApi = new Tickets();

export default TicketsApi;
